import ImageDescription from './ImageDescription';

export default ImageDescription;
